import React, { Component } from "react";
import styles from "../../assets/css/modules/health-information/healthinformationsearchbox.css";
import Store from "../../content/Store";
import Content from "../../content/Content";

export default class HealthInformationSearchBox extends Component {
  render() {
    return (
      <div className="col-lg-4 col-md-6">
        <div className={styles.healthInformationBoxCard}>
          <div className={styles.healthInformationBoxImageCardBg}>
            <button
              className={styles.imgContainer + " img-link"}
              style={{
                backgroundImage: `url(${this.props.healthRecommendation.ImageUrl})`
              }}
              onClick={() =>
                this.props.onDiscoverLinkClicked(
                  this.props.healthRecommendation.Url
                )
              }
            />
          </div>
          <div className={styles.healthInformationBoxImageCardWrapper}>
            <div
              className={styles.healthInformationBoxImageCardWrapperSameHeight}
            >
              <h4>{this.props.healthRecommendation.ShortTitle}</h4>
              <p>{this.props.healthRecommendation.ShortDescription}</p>
              <div className={styles.descriptionAfter} />
            </div>

            <div className={styles.healthInformationBoxFooter}>
              <p className={styles.healthInformationBoxDomain}>
                {this.props.healthRecommendation.HostName}
              </p>
              <button
                onClick={() =>
                  this.props.onDiscoverLinkClicked(
                    this.props.healthRecommendation.Url
                  )
                }
                className={styles.healthInformationBoxCardLink + " btn-link"}
              >
                <Content name={Store.HealthInformation.DiscoverText} />{" "}
                <span className="ml-2">➔</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
